import { cn } from "@/lib/utils";
import { useTranslation } from "@repo/shared/i18n";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { ButtonHTMLAttributes } from "react";

interface ArrowButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  direction: "left" | "right";
}

const ArrowButton = ({
  direction,
  className,
  "aria-label": ariaLabel,
  ...props
}: ArrowButtonProps) => {
  const { t } = useTranslation();
  const Icon = direction === "left" ? ArrowLeft : ArrowRight;
  return (
    <button
      type="button"
      aria-label={
        ariaLabel ?? (direction === "left" ? t("previous") : t("next"))
      }
      className={cn(
        "flex size-7 shrink-0 items-center justify-center rounded-full",
        "border border-neutral-700 bg-neutral-800 text-neutral-200 shadow-button-new transition-all duration-200",
        "hover:bg-neutral-700 disabled:cursor-not-allowed disabled:opacity-40",
        className,
      )}
      {...props}
    >
      <Icon className="size-4" />
    </button>
  );
};

export default ArrowButton;
